const Radio = {
    parts: ['icon', 'label', 'control'],
    defaultProps: { colorScheme: 'blue' },
    baseStyle: {},
    sizes: {},
    variants: {},
};

export default Radio;
